import { BreadCrumbs } from '@app/components/BreadCrumbs';
import { Layout } from '@app/components/Layout';
import { Actions } from './Actions';
import { Table } from './Table';

export function Events() {
  return (
    <Layout>
      <BreadCrumbs
        links={[
          {
            label: 'Dashboard',
            link: '/',
          },
          {
            label: 'Events & Workshops',
            link: '/events/other',
          },
        ]}
      />
      <Actions />
      <Table />
    </Layout>
  );
}
